import React from 'react'
import styled from 'styled-components'
import ServiceSequence from '../../components/kiosk/KioskContent/ServiceSequence/ServiceSequence'
import {useUIDispatch} from '../../context/UIContext'

const ServiceRequest = ({
  parentPage,
  user,
  initialForm,
  activityType,
  probType,
  catalogHeader,
  hideFields,
  instructions
}) => {
  const uiDispatch = useUIDispatch()

  const onComplete = () =>
    uiDispatch({type: 'setContent', payload: {content: parentPage}})

  const onSequenceCancel = () =>
    uiDispatch({type: 'setContent', payload: {content: parentPage}})

  const onHeaderAction = ({type}) => {
    if (type === 'CANCEL') {
      uiDispatch({
        type: 'setContent',
        payload: {content: parentPage || 'DASHBOARD'}
      })
    }
  }

  return (
    <StyledContainer>
      <ServiceSequence
        onComplete={onComplete}
        onSequenceCancel={onSequenceCancel}
        user={user}
        onHeaderAction={onHeaderAction}
        initialForm={initialForm}
        activityType={activityType}
        probType={probType}
        parentPage={parentPage}
        catalogHeader={catalogHeader}
        hideFields={hideFields}
        instructions={instructions}
      />
    </StyledContainer>
  )
}

export default ServiceRequest

const StyledContainer = styled.div`
  height: 100vh;
  width: 100vw;
  box-sizing: border-box;
`
